import { SvelteComponent, init, safe_not_equal, element, attr, insert, listen, detach, space, text, create_component, toggle_class, append, set_input_value, mount_component, set_data, transition_in, transition_out, destroy_component, run_all, component_subscribe, noop, binding_callbacks } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { writable } from '../../external_node_modules/svelte/store/index.mjs.js';
import { t } from '../../i18n.js';
import { COMMIT_TSV_METHODS, TSV_METHODS_MAP } from '../../constants/web/tsvMethods.js';
import { purchaseProduct } from '../../store/actions/purchase.js';
import purchaseTwoFactor, { setSecureCode, setValidationErrorCode, setMethod } from '../../store/purchaseTwoFactor.js';
import Button from '../shared/components/Button/Button.svelte.js';
import currentProduct from '../../store/currentProduct.js';
import activePaymentMethod from '../../store/activePaymentMethod.js';
import transactionId from '../../store/transactionId.js';
import tsv from '../../store/tsv.js';
import { ButtonTheme } from '../../interfaces/ButtonTheme.js';
import './TwoFactorEnabled.css.js';

/* src/ui/PurchaseProduct/TwoFactorEnabled.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let div;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*isOTPBackup*/ ctx[4]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "secure-backup wcl-1ofx76k");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);

			if (!mounted) {
				dispose = listen(div, "click", /*toggleBackupMode*/ ctx[14]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
			mounted = false;
			dispose();
		}
	};
}

// (136:4) {:else}
function create_else_block(ctx) {
	let t_1_value = t('Использовать резервный код') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (134:4) {#if isOTPBackup}
function create_if_block_1(ctx) {
	let t_1_value = t('Использовать код аутентификатора') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (142:2) <Button disabled="{!$isValid}" on:click="{buy}" theme="{ButtonTheme.secondary}">
function create_default_slot(ctx) {
	let t_1_value = t('Оплатить') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let t1;
	let div2;
	let input;
	let input_minlength_value;
	let input_maxlength_value;
	let t2;
	let div1;
	let t3_value = (/*$purchaseTwoFactor*/ ctx[1].validationErrorCode || '') + "";
	let t3;
	let t4;
	let show_if = [COMMIT_TSV_METHODS.OTP, COMMIT_TSV_METHODS.BACKUP].includes(/*commitMethod*/ ctx[0]);
	let t5;
	let div3;
	let button;
	let current;
	let mounted;
	let dispose;
	let if_block = show_if && create_if_block(ctx);

	button = new Button({
			props: {
				disabled: !/*$isValid*/ ctx[8],
				theme: ButtonTheme.secondary,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*buy*/ ctx[16]);

	return {
		c() {
			div0 = element("div");
			div0.textContent = `${t('Для завершения покупки введите код в это поле и нажмите кнопку «Оплатить».')}`;
			t1 = space();
			div2 = element("div");
			input = element("input");
			t2 = space();
			div1 = element("div");
			t3 = text(t3_value);
			t4 = space();
			if (if_block) if_block.c();
			t5 = space();
			div3 = element("div");
			create_component(button.$$.fragment);
			attr(div0, "class", "secure-description wcl-1ofx76k");
			attr(input, "placeholder", /*inputPlaceholderText*/ ctx[7]);
			attr(input, "minlength", input_minlength_value = /*validationConfig*/ ctx[6].minLength || 1);
			attr(input, "maxlength", input_maxlength_value = /*validationConfig*/ ctx[6].maxLength || 12);
			attr(input, "type", "text");
			attr(input, "autocomplete", "off");
			input.autofocus = true;
			attr(input, "class", "wcl-1ofx76k");
			toggle_class(input, "with-error", /*$purchaseTwoFactor*/ ctx[1].validationErrorCode);
			toggle_class(input, "focused", /*$purchaseTwoFactor*/ ctx[1].code);
			attr(div1, "class", "validation-error wcl-1ofx76k");
			toggle_class(div1, "visible", /*$purchaseTwoFactor*/ ctx[1].validationErrorCode);
			attr(div2, "class", "secure-input wcl-1ofx76k");
			attr(div3, "class", "secure-action wcl-1ofx76k");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			insert(target, div2, anchor);
			append(div2, input);
			set_input_value(input, /*secureCode*/ ctx[5]);
			/*input_binding*/ ctx[19](input);
			append(div2, t2);
			append(div2, div1);
			append(div1, t3);
			/*div2_binding*/ ctx[20](div2);
			insert(target, t4, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, t5, anchor);
			insert(target, div3, anchor);
			mount_component(button, div3, null);
			current = true;
			input.focus();

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[18]),
					listen(input, "focus", /*onFocus*/ ctx[13]),
					listen(input, "drop", /*onDrop*/ ctx[11]),
					listen(input, "keypress", /*onKeyPress*/ ctx[10]),
					listen(input, "input", /*onInput*/ ctx[12]),
					listen(div2, "animationend", /*onInputAnimationEnd*/ ctx[15])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*inputPlaceholderText*/ 128) {
				attr(input, "placeholder", /*inputPlaceholderText*/ ctx[7]);
			}

			if (!current || dirty & /*validationConfig*/ 64 && input_minlength_value !== (input_minlength_value = /*validationConfig*/ ctx[6].minLength || 1)) {
				attr(input, "minlength", input_minlength_value);
			}

			if (!current || dirty & /*validationConfig*/ 64 && input_maxlength_value !== (input_maxlength_value = /*validationConfig*/ ctx[6].maxLength || 12)) {
				attr(input, "maxlength", input_maxlength_value);
			}

			if (dirty & /*secureCode*/ 32 && input.value !== /*secureCode*/ ctx[5]) {
				set_input_value(input, /*secureCode*/ ctx[5]);
			}

			if (dirty & /*$purchaseTwoFactor*/ 2) {
				toggle_class(input, "with-error", /*$purchaseTwoFactor*/ ctx[1].validationErrorCode);
			}

			if (dirty & /*$purchaseTwoFactor*/ 2) {
				toggle_class(input, "focused", /*$purchaseTwoFactor*/ ctx[1].code);
			}

			if ((!current || dirty & /*$purchaseTwoFactor*/ 2) && t3_value !== (t3_value = (/*$purchaseTwoFactor*/ ctx[1].validationErrorCode || '') + "")) set_data(t3, t3_value);

			if (dirty & /*$purchaseTwoFactor*/ 2) {
				toggle_class(div1, "visible", /*$purchaseTwoFactor*/ ctx[1].validationErrorCode);
			}

			if (dirty & /*commitMethod*/ 1) show_if = [COMMIT_TSV_METHODS.OTP, COMMIT_TSV_METHODS.BACKUP].includes(/*commitMethod*/ ctx[0]);

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(t5.parentNode, t5);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const button_changes = {};
			if (dirty & /*$isValid*/ 256) button_changes.disabled = !/*$isValid*/ ctx[8];

			if (dirty & /*$$scope*/ 536870912) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div2);
			/*input_binding*/ ctx[19](null);
			/*div2_binding*/ ctx[20](null);
			if (detaching) detach(t4);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t5);
			if (detaching) detach(div3);
			destroy_component(button);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let prepareMethod;
	let commitMethod;
	let validationConfig;
	let inputPlaceholderText;
	let $transactionId;
	let $purchaseTwoFactor;
	let $tsv;
	let $activePaymentMethod;
	let $currentProduct;
	let $isValid;
	component_subscribe($$self, transactionId, $$value => $$invalidate(21, $transactionId = $$value));
	component_subscribe($$self, purchaseTwoFactor, $$value => $$invalidate(1, $purchaseTwoFactor = $$value));
	component_subscribe($$self, tsv, $$value => $$invalidate(22, $tsv = $$value));
	component_subscribe($$self, activePaymentMethod, $$value => $$invalidate(23, $activePaymentMethod = $$value));
	component_subscribe($$self, currentProduct, $$value => $$invalidate(24, $currentProduct = $$value));

	var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
			? value
			: new P(function (resolve) {
						resolve(value);
					});
		}

		return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch(e) {
						reject(e);
					}
				}

				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch(e) {
						reject(e);
					}
				}

				function step(result) {
					result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
				}

				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
	};

	const isValid = writable(false);
	component_subscribe($$self, isValid, value => $$invalidate(8, $isValid = value));
	let inputContainer = null;
	let inputElement = null;
	let isOTPBackup = false;
	let secureCode = '';

	function setValidationState(valid) {
		isValid.update(state => valid);
	}

	function preventDefault(e, text) {
		if (validationConfig && !validationConfig.allowedChar.test(text)) {
			e.preventDefault();
			return false;
		}
	}

	function onKeyPress(e) {
		if (e.key === 'Enter') {
			buy();
		}

		preventDefault(e, e.key);
	}

	function onDrop(e) {
		preventDefault(e, e.dataTransfer.getData('text'));
	}

	function onInput(e) {
		const value = e.target.value.trim();

		if (validationConfig) {
			if (value.length >= validationConfig.minLength && value.length <= validationConfig.maxLength) {
				setValidationState(true);
			} else {
				setValidationState(false);
			}
		}

		setSecureCode(value);
	}

	function onFocus() {
		setValidationErrorCode(null);
	}

	function toggleBackupMode() {
		$$invalidate(5, secureCode = '');
		setValidationErrorCode(null);

		if (isOTPBackup) {
			$$invalidate(4, isOTPBackup = false);
			setMethod(COMMIT_TSV_METHODS.OTP);
		} else {
			$$invalidate(4, isOTPBackup = true);
			setMethod(COMMIT_TSV_METHODS.BACKUP);
		}
	}

	function onInputAnimationEnd() {
		if (inputContainer) {
			inputContainer.classList.remove('shake-animation');
		}
	}

	function startInputAnimation() {
		if (inputContainer) {
			inputContainer.classList.add('shake-animation');
		}
	}

	function buy() {
		return __awaiter(this, void 0, void 0, function* () {
			if (!$isValid) {
				startInputAnimation();

				if (inputElement) {
					inputElement.focus();
				}

				return false;
			}

			yield purchaseProduct($currentProduct, $activePaymentMethod, $tsv, $purchaseTwoFactor, $transactionId);
		});
	}

	function input_input_handler() {
		secureCode = this.value;
		$$invalidate(5, secureCode);
	}

	function input_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputElement = $$value;
			$$invalidate(3, inputElement);
		});
	}

	function div2_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputContainer = $$value;
			$$invalidate(2, inputContainer);
		});
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$purchaseTwoFactor*/ 2) {
			$$invalidate(17, prepareMethod = $purchaseTwoFactor.method);
		}

		if ($$self.$$.dirty & /*prepareMethod*/ 131072) {
			$$invalidate(0, commitMethod = TSV_METHODS_MAP[prepareMethod] || prepareMethod);
		}

		if ($$self.$$.dirty & /*commitMethod*/ 1) {
			$$invalidate(6, validationConfig = ({
				[COMMIT_TSV_METHODS.OTP]: {
					minLength: 6,
					maxLength: 6,
					allowedChar: /^\d+$/
				},
				[COMMIT_TSV_METHODS.BACKUP]: {
					minLength: 6,
					maxLength: 8,
					allowedChar: /^\w+$/
				},
				[COMMIT_TSV_METHODS.WGNPS]: {
					minLength: 6,
					maxLength: 6,
					allowedChar: /^\d+$/
				}
			})[commitMethod]);
		}

		if ($$self.$$.dirty & /*commitMethod*/ 1) {
			$$invalidate(7, inputPlaceholderText = ({
				[COMMIT_TSV_METHODS.OTP]: t('Код аутентификатора'),
				[COMMIT_TSV_METHODS.WGNPS]: t('Код из СМС'),
				[COMMIT_TSV_METHODS.BACKUP]: t('Резервный код')
			})[commitMethod] || '');
		}
	};

	return [
		commitMethod,
		$purchaseTwoFactor,
		inputContainer,
		inputElement,
		isOTPBackup,
		secureCode,
		validationConfig,
		inputPlaceholderText,
		$isValid,
		isValid,
		onKeyPress,
		onDrop,
		onInput,
		onFocus,
		toggleBackupMode,
		onInputAnimationEnd,
		buy,
		prepareMethod,
		input_input_handler,
		input_binding,
		div2_binding
	];
}

class TwoFactorEnabled extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export { TwoFactorEnabled as default };
//# sourceMappingURL=TwoFactorEnabled.svelte.js.map
